module.exports = __webpack_public_path__ + "static/preview-user-lists-scale-medium-86c44f9c3c7d3fa8eaee090f744a0421.png";